exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/error/error.component.scss
// module id = ../../../../../src/app/shared/error/error.component.scss
// module chunks = main